"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const mediaQuery_1 = require("../../cssMixins/mediaQuery");
const useToolsState_1 = require("../../hooks/useToolsState");
function LabelButton(props) {
    var _a, _b, _c, _d;
    const analytics = (0, analytics_1.useAnalytics)();
    const state = (0, useToolsState_1.useToolsState)();
    const { onClick, disabled, tooltipPlace, isSelected } = props;
    const { t } = (0, i18n_1.useTranslation)();
    const isLower = (0, ui_1.useScreenBreakpoint)(mediaQuery_1.size.tablet);
    const shouldShowLabelsButton = !!((_b = (_a = state === null || state === void 0 ? void 0 : state.labelsState) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.length) ||
        (isLower && !!((_d = (_c = state === null || state === void 0 ? void 0 : state.stickiesState) === null || _c === void 0 ? void 0 : _c.stickies) === null || _d === void 0 ? void 0 : _d.length));
    const onHandleClick = () => {
        analytics.log('show_hide_labels_pressed');
        onClick();
    };
    if (!shouldShowLabelsButton) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(TooltipButton, { tooltip: {
            place: tooltipPlace,
            context: isSelected
                ? t(i18n_1.Strings.toolbar.hideLabelsTooltip)
                : t(i18n_1.Strings.toolbar.showLabelsTooltip),
        }, onClick: onHandleClick, disabled: disabled, isSelected: isSelected, children: (0, jsx_runtime_1.jsx)(ui_1.Icon, { name: ui_1.Icons.Label_Main, selected: isSelected, width: 24, height: 24 }) }));
}
const TooltipButton = (0, ui_1.withTooltip)(ui_1.ToolBarBaseButton);
exports.default = LabelButton;
